import * as React from 'react';

import { Container } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import {
  StoreActionsButton,
  StoreActionsCard,
} from 'pages/store-locator/new-ui/store-actions/components';
import { designTokens } from 'styles/constants/design-tokens';
import { fadeIn } from 'utils/style/animations';

const FadeIn = styled.div`
  animation: 0.2s ${fadeIn} forwards;
  opacity: 0;
`;

interface IStoreActionsViewProps {
  onClick: () => void;
}

export const StoreSelectAction: React.VFC<IStoreActionsViewProps> = ({ onClick }) => {
  const { formatMessage } = useIntl();
  return (
    <FadeIn>
      <Container background={designTokens['background-default']}>
        <StoreActionsCard>
          <StoreActionsButton
            icon={'order'}
            text={formatMessage({ id: 'select' })}
            onClick={onClick}
            id="order"
          />
        </StoreActionsCard>
      </Container>
    </FadeIn>
  );
};
